import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createStationOilEngineInfo, deleteStationOilEngineInfo as _deleteStationOilEngineInfo, deleteStationOilEngineInfoByIds, updateStationOilEngineInfo, findStationOilEngineInfo, getStationOilEngineInfoList } from '@/api/bairun/stationOilEngineInfo'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'StationOilEngineInfo',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatOilEngineStatusTag: function formatOilEngineStatusTag(bool) {
      if (bool != null) {
        return bool === 1 ? 'success' : bool === 2 ? 'danger' : bool === 3 ? 'warning' : bool === 4 ? 'info' : '';
      } else {
        return 'info';
      }
    },
    formatOilEngineStatusText: function formatOilEngineStatusText(bool) {
      if (bool != null) {
        return bool === 1 ? '使用中' : bool === 2 ? '已关闭' : bool === 3 ? '维护中' : bool === 4 ? '离线' : '未知';
      } else {
        return '';
      }
    },
    formatColor: function formatColor(code) {
      switch (code) {
        case 92:
          return 'primary';

        case 95:
          return 'success';

        case 98:
          return 'info';

        case 0:
          return 'warning';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getStationOilEngineInfoList,
      stationBaseList: [],
      actionType: null,
      oilEngineStatusDict: [],
      dialogFormVisible: false,
      dialogStatusFormVisible: false,
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        stationId: null,
        oilEngineName: null,
        oilEngineNo: null,
        oilGunNum: null,
        oilEngineStatus: null,
        oilEngineRemark: null
      },
      rules: {
        stationId: [{
          required: true,
          message: '请选择需要配置的油站',
          trigger: 'blur'
        }],
        oilEngineName: [{
          required: true,
          message: '请输入油机名',
          trigger: 'blur'
        }],
        oilEngineNo: [{
          required: true,
          message: '请输入油机编号',
          trigger: 'blur'
        }],
        oilGunNum: [{
          required: true,
          message: '请输入油枪数量',
          trigger: 'blur'
        }],
        oilEngineStatus: [{
          required: true,
          message: '请选择油机状态',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getTableData();

              case 2:
                _context2.next = 4;
                return _this3.setStartMap();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    updateStationOilEngineInfo: function updateStationOilEngineInfo(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return findStationOilEngineInfo({
                  ID: row.ID
                });

              case 2:
                res = _context3.sent;
                _this4.actionType = 'update';

                if (res.code === 0) {
                  _this4.formData = res.data.resStationOilEngineInfo;
                  _this4.dialogFormVisible = true;
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        stationId: null,
        oilEngineName: null,
        oilEngineNo: null,
        oilGunNum: null,
        oilEngineStatus: null,
        oilEngineRemark: null
      };
    },
    deleteStationOilEngineInfo: function deleteStationOilEngineInfo(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                row.visible = false;
                _context4.next = 3;
                return _deleteStationOilEngineInfo({
                  ID: row.ID
                });

              case 3:
                res = _context4.sent;

                if (!(res.code === 0)) {
                  _context4.next = 9;
                  break;
                }

                _this5.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this5.tableData.length === 1 && _this5.page > 1) {
                  _this5.page--;
                }

                _context4.next = 9;
                return _this5.getTableData();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBatchDeleteStationOilEngineInfo: function onBatchDeleteStationOilEngineInfo() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ids = [];
                _this6.multipleSelection && _this6.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context5.next = 4;
                return deleteStationOilEngineInfoByIds({
                  ids: ids
                });

              case 4:
                res = _context5.sent;

                if (!(res.code === 0)) {
                  _context5.next = 11;
                  break;
                }

                _this6.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this6.tableData.length === ids.length) {
                  _this6.page--;
                }

                _this6.deleteVisible = false;
                _context5.next = 11;
                return _this6.getTableData();

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.$refs['elForm'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (valid) {
                              _context6.next = 2;
                              break;
                            }

                            return _context6.abrupt("return");

                          case 2:
                            _context6.t0 = _this7.actionType;
                            _context6.next = _context6.t0 === 'create' ? 5 : _context6.t0 === 'update' ? 9 : 13;
                            break;

                          case 5:
                            _context6.next = 7;
                            return createStationOilEngineInfo(_this7.formData);

                          case 7:
                            res = _context6.sent;
                            return _context6.abrupt("break", 15);

                          case 9:
                            _context6.next = 11;
                            return updateStationOilEngineInfo(_this7.formData);

                          case 11:
                            res = _context6.sent;
                            return _context6.abrupt("break", 15);

                          case 13:
                            _this7.$message({
                              type: 'info',
                              message: '无效操作'
                            });

                            return _context6.abrupt("return");

                          case 15:
                            if (!(res.code === 0)) {
                              _context6.next = 20;
                              break;
                            }

                            _this7.$message({
                              type: 'success',
                              message: '操作成功'
                            });

                            _this7.closeDialog();

                            _context6.next = 20;
                            return _this7.getTableData();

                          case 20:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 唤起弹窗 新增油机基础信息
    openAddStationOilEngineInfoDialog: function openAddStationOilEngineInfoDialog() {
      this.actionType = 'create';
      this.dialogFormVisible = true;
    },
    setStartMap: function setStartMap() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var stationBaseData;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return getDict('oilEngineStatus');

              case 2:
                _this8.oilEngineStatusDict = _context8.sent;
                _context8.next = 5;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 5:
                stationBaseData = _context8.sent;
                _this8.stationBaseList = stationBaseData.data.list;

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  }
};